import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '200vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIADAgents = {
    name: 'Download Agent',
    imageUrl: '../../images/ADAgents.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIADInstall = {
    name: 'User Form',
    imageUrl: '../../images/ADInstall.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIADInstall2 = {
    name: 'User Form',
    imageUrl: '../../images/ADInstall2.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIADAddnew = {
    name: 'User Form',
    imageUrl: '../../images/ADAddnew.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADProvision = {
    name: 'User Form',
    imageUrl: '../../images/ADProvision.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADUpdate = {
    name: 'User Form',
    imageUrl: '../../images/ADUpdate.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADStatus = {
    name: 'User Form',
    imageUrl: '../../images/ADStatus.png',
    imageSize: "99%",
    bradius: 20,
  };

export const ADAgents = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Agent Download</b><br/><br/>
      A PDF Version of the agent prerequisites and installation instructions is available&nbsp;
      <a href='https://portal.dataspotlite.com/docs/cybroker_setup.pdf' target="_blank">HERE</a>. <br/><br/>
      The CYRISMA Agent is the data collector for any CYRISMA web instance. There are two modes of operation: <br/><br/>
      <ol style={{marginLeft: '4em'}}>
      <li>The agent can collect Vulnerability, Configuration, and Sensitivity detail from 
      the host machine it is installed on. This is “Agent Based” scanning since each 
      host requires an agent to perform the collection duties. </li>
      <li>The agent can collect Vulnerability, Configuration, and Sensitivity detail from OTHER 
      Windows/MAC/Linux target machines in the network. It can also scan IP ranges for the 
      discovery of network assets and unauthenticated vulnerabilities. This is “Agentless” 
      scanning since the targets do not need agents installed. HOWEVER, the host running 
      the agent requires network credentials to allow complete access to the target to 
      collect the scan detail. </li></ol><br/><br/>
      In most environments, agents are set up using a combination of the above: 
      Remote machines that are generally off-network must have an agent installed on the 
      remote host itself, and local targets can have agents installed, or be scanned 
      from a Windows host on the same network that has an agent and credentials to 
      scan with.
      </div>
      <div style={helpimg}>
      <img
        src={UIADAgents.imageUrl}
        alt={'Image of ' + UIADAgents.name}
        style={{
          width: UIADAgents.imageSize,
          borderRadius: UIADAgents.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADPrereq = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Agent Prerequisites</b><br/><br/>
      Prerequisites include:
      <ul style={{marginLeft: '4em'}}>
      <li>Sensor must be installed on a Windows Server (2012 r2, 2016, 2019) or a Windows 10, 11 workstation. </li><br/>
      <li>Sensor will need to communicate with servers in the cyrisma.com domain. Be sure 
      any web content filters or firewalls are set to allow communication between the 
      local agent and cyrisma.com. Anti-Virus settings should exempt C:\Cyrisma_Agent. 
      Anti-Spam should allow mail from cyrisma.com. </li><br/>
      <li>Sensor uses Java for some scan operations. Java requires a minimum of 1024MB of AVAILABLE memory
      on the agent host machine in order to complete the scans.</li><br/>
      <li>Agents REQUIRE DotNet 4.8 or above. The installer attempts to install DotNet if 
      it is missing. However, depending on OS and Open file status, DotNet installation 
      may require a reboot, so it is best to install in advance and complete any necessary 
      reboots prior to sensor installation. If needed, you may download DotNet from 
      here: https://portal.dataspotlite.com/jv_dl/dotnet.exe </li><br/>
      <li>If planning to perform network discovery scans or scans of target machines that 
      do not have an agent installed, create an account with Admin rights on the network 
      and have the credentials available when you are ready to provision agents. </li></ul>
      </div>
      <div style={helpimg}>

      </div>
    </div>
  );
};

export const ADInstall = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Agent Installation</b><br/><br/>
      The agent can be installed by simply downloading and executing, or by 
      downloading and setting up with a deployment script for automated, mass 
      installation using preexisting software deployment utilities. <br/><br/>
      
      Download the agent here: https://msp.cyrisma.com/dl/Cyrisma_Setup.exe <br/><br/>
      
      Graphical Installer: <br/><br/>
      If using the graphical installer (installing on a single host): <br/><br/>
      Double click the downloaded Cyrisma_Setup.exe file. After a few moments, a 
      prompt for the Installation key and URL will appear. <br/><br/>

      <img
        src={UIADInstall.imageUrl}
        alt={'Image of ' + UIADInstall.name}
        style={{
          width: UIADInstall.imageSize,
          borderRadius: UIADInstall.bradius,
        }}
      />
      <br/><br/>
      Use the Installation Key from the Scan Agent page of the CYRISMA Command 
      Center and use the base URL of the Command Center instance as the URL. <br/><br/>
      
      Hit Next to be presented with the End User License Agreement and then 
      Next again and the files will unpack from the Installer package. Once 
      extraction is complete, you will see: <br/><br/>

      <img
        src={UIADInstall2.imageUrl}
        alt={'Image of ' + UIADInstall2.name}
        style={{
          width: UIADInstall2.imageSize,
          borderRadius: UIADInstall2.bradius,
        }}
      />
      <br/><br/>
      As indicated, clicking next will <b>CLOSE THE INSTALLER WINDOW.</b> The 
      final agent setup completes in the background. When running from a desktop 
      session, you will see a momentary "Setup Complete" pop-up once the setup 
      completes. <br/><br/>
      The setup process also maintains a local log of setup activity here: <br/><br/>
      C:\CYRISMA_Agent\logs\CYRISMA_Agent_Install.log <br/><br/>
      You may review this log if there were problems completing the setup. <br/><br/>
      The agent will automatically check for newer versions of the agent and 
      update as needed. This activity will be found in the Agent Log here: <br/><br/>
      C:\CYRISMA_Agent\logs\Agent-log_[Timestamp].txt <br/><br/>
      <b><u>Command Line Installer:</u></b> <br/><br/>
      If using a Software deployment package manager, the agent can also be deployed 
      using the Command Line: <br/><br/>
      <b>Cyrisma_Setup /verysilent /key=nnnn-nnnn-nnnn /url=https://ccNNNNNN.cyrisma.com </b><br/>
      (where nnn represents your installation key and URL string)<br/><br/>
      In addition, when using the command line option, you may also include the 
      alternate parameter:
      /role=sensor. <br/><br/>
      This installation switch will install the optional packet capture driver if this 
      agent will be used to perform unauthenticated scans of an IP subnet.
      </div>
      <div style={helpimg}>
      </div>
    </div>
  );
};

export const ADProvision = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Provision New Agent</b><br/><br/>
      Once installed (whether via desktop installer or command line script), the agent 
      must be provisioned. Provisioning is the step of credentialing the agent and 
      granting the right to collect scan data for this instance. <br/><br/>
      Go to Admin -&gt; Scan Agents and scroll to the “Update or Add Agents” section. 
      Now select “Provision New Agent”. <br/><br/>

      Any host machines where the agent has been installed, but not yet provisioned 
      will appear in the list.<br/><br/>
      <img
        src={UIADAddnew.imageUrl}
        alt={'Image of ' + UIADAddnew.name}
        style={{
          width: UIADAddnew.imageSize,
          borderRadius: UIADAddnew.bradius,
        }}
      />
      Agents can be provisioned two different ways: <br/><br/>
      <ol style={{marginLeft: '4em'}}>
      <li>The agent will run scans of its local host only. In this case, the agent 
      service can run with its default Windows “System” account and does not 
      need network credentials. </li>
      <li>The agent will run scans of the network or other machines on the network. 
      In this case, network credentials are needed. </li>
      </ol><br/>
      If running local only, simply select the agent machines from the list and 
      submit, the credential area remains greyed out and disabled. <br/><br/>
      If running network scans, create a service account within the network in 
      advance of provisioning. This service account will require local admin rights 
      on any target machine to be included in an authenticated scan. When making the 
      service account and assigning a password, please note the password restrictions 
      on special characters. The only special characters that can be included in the 
      password are: ) @ ! - _ ( <br/><br/>
      When operating within a domain environment, use the local “NetBIOS” version 
      of the domain name and not the Global “UPN” format. <br/><br/>
      Once credentials and domain information have been entered, select the 
      agent(s) to use these credentials and submit. <br/><br/>
      Once agents have been provisioned, they begin to show in the “Agent Status” 
      section on the Scan Agent page. Initially, the “Last Checked” value of 
      recently provisioned agents will be blank until the agent completes its 
      provisioning process and begins checking in. This process can take from 
      1 to 10 minutes to complete. Once check-in starts, agents typically check 
      in at 5-minute intervals to receive any direction to begin a scan activity. <br/><br/>
      NOTE: Even though <u>Network Agents</u> have credentials available, the agent 
      service itself is still running using the local "System" account. To 
      complete the process of granting an agent network rights, reconfigure 
      the service to also run using the <u>same</u> network account and then, restart 
      the service. 
      </div>
      <div style={helpimg}>
      <img
        src={UIADProvision.imageUrl}
        alt={'Image of ' + UIADProvision.name}
        style={{
          width: UIADProvision.imageSize,
          borderRadius: UIADProvision.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADUpdate = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Update Existing Agents</b><br/><br/>
      To update an existing agent, select “Update Existing Agent” on the Scan 
      Agents page, and make updates to the selected agent details as necessary. <br/><br/>
      <b>Note: It is especially important to update the password if the agent 
      service account credentials have been updated on the target or target 
      domain. An incorrect password here can cause the agent to scan with a 
      wrong password and eventually lock out the agent account!</b> <br/><br/>
      <b>Memory Threshold:</b> This is the maximum amount of memory (in percent of 
      total system memory on this target) that an agent is allowed to consume. 
      40% is the default and works very well in most cases. However, targets 
      with small amounts of system memory may need a higher percentage to 
      allow for enough memory for the agent to perform its duties. For 
      vulnerability scanning, machines hosting an agent will require a 
      minimum of 4 GB of total memory installed in the machine. <br/><br/>
      <b>Physical:</b> This is an optional note for convenience. <br/><br/>
      <b>Status:</b> You may disable an agent, which will prevent it from taking 
      any further instruction from the command center. Disabled agents can 
      be enabled at any time. <br/><br/>
      <b><u>Deleting Agents</u></b> <br/><br/>
      Use the "Delete" button at the bottom of the page to: <br/>
      <ol style={{marginLeft: '4em'}}>
      <li>Delete the agent from the Command Center web interface. </li>
      <li>Set an uninstall signal requesting that the agent uninstall itself at next check-in.</li>
      </ol>
      </div>
      <div style={helpimg}>
      <img
        src={UIADUpdate.imageUrl}
        alt={'Image of ' + UIADUpdate.name}
        style={{
          width: UIADUpdate.imageSize,
          borderRadius: UIADUpdate.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADStatus = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Agent Status and Actions</b><br/><br/>
      From the agent status pane, you can see details about the agent status, including 
      the host machine the agent is installed on, current scan activity (running task), 
      and last check-in time. Agents that have not checked in and are presumed to be 
      down will turn red. <br/><br/>
      Agents that are permanently offline will eventually reach 840 hours, and the time 
      value will no longer increase. These agents can be disabled to remove them from 
      the view (see Update Existing Agents section below). <br/><br/>
      The restart button (in the action column) will set a restart signal, requesting 
      that the agent restart at the next check-in. Keep in mind that if an agent is not 
      checking in, clicking a restart will do nothing since the agent is not checking in 
      to receive the request to perform the restart. In that case, visit the machine 
      where the agent service is installed and restart the agent service from there. 
      </div>
      <div style={helpimg}>
      <img
        src={UIADStatus.imageUrl}
        alt={'Image of ' + UIADStatus.name}
        style={{
          width: UIADStatus.imageSize,
          borderRadius: UIADStatus.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADPerms = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Agent Permissions</b><br/><br/>
      The agent has been granted permission to perform scans according to the 
      credentials that have been supplied. In a Microsoft Windows environment, agents 
      rely on the Windows Security Framework to operate. This means Windows remote 
      management features must be enabled to allow the agent complete access to 
      perform Network Discovery, Agentless Vulnerability Scanning, and Secure 
      Baseline Scans of the network hosting the agent. <br/><br/>
      In a domain environment, this has generally already been set up. However, 
      keep in mind that Firewall Rules, WinRM settings, Endpoint Protection services, 
      and Powershell permissions may prevent the agent from performing scans. 
      Agent logs can provide assistance by indicating where the Windows Security 
      Framework may need adjustment. <br/><br/>In non-domain environments 
      (Standalone, Remote Workforce, BYOD, Microsoft InTune MDM), the Windows 
      Security Framework will likely need manual adjustment and setup to allow 
      agent access to all machines. <br/><br/>
      In networks that are non-domain, simply installing agents on all Windows 
      machines may be the easiest course. In that case, agents are only responsible 
      for scanning the host it is installed on. The agent service, by default, is 
      already operating using local system permissions. In a domain environment, 
      it is best to change the agent service credentials to match the credentials 
      that were supplied during provisioning. 
      </div>
      <div style={helpimg}>

      </div>
    </div>
  );
};
